import './typedefs'
import http from '@/http'

const PATH = '/staff/users'

export default {
    /**
     * @param {ListQuery} params
     * @returns {Promise<void>}
     */
    async listLogs (params) {
        try {
            const response = await http.get(`${PATH}/sso/logs`, {params})
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    /**
     * @param {ListQuery} params
     * @returns {Promise<void>}
     */
    async listStaffMembers (params) {
        try {
            const response = await http.get(PATH, {params})

            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    /**
     * @param {StaffMemberQuery} data
     * @returns {Promise<void>}
     */
    async showStaffMember (data) {
        try {
            const response = await http.get(`${PATH}/${data.id}`)

            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    /**
     * @param {StaffMember} data
     * @returns {Promise<void>}
     */
    async createStaffMember (data) {
        try {
            const response = await http.post(PATH, data)

            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    /**
     * @param {StaffMember} data
     * @returns {Promise<void>}
     */
    async updateStaffMember (data) {
        try {
            const response = await http.put(`${PATH}/${data.id}`, data)

            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    /**
     * @param {{id: number}} data
     * @returns {Promise<void>}
     */
    async deactivateStaffMember (data) {
        try {
            const response = await http.delete(`${PATH}/${data.id}`)

            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    /**
     * @param {{id: number}} data
     * @returns {Promise<undefined|*>}
     */
    async deactivateStaffMemberSso (data) {
        try {
            const response = await http.delete(`${PATH}/${data.id}/sso`)

            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    /**
     * @param {{id: number}} data
     * @returns {Promise<void>}
     */
    async requestSipcentricAccount (data) {
        try {
            const response = await http.post(`${PATH}/${data.id}/sipcentric`)

            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    /**
     * @param {{id: number}} data
     * @returns {Promise<void>}
     */
    async sendSipcentricAccountDetails (data) {
        try {
            const response = await http.post(`${PATH}/${data.id}/sipcentric/details`)

            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    /**
     * @param {{id: number}} data
     * @returns {Promise<undefined|*>}
     */
    async sendSsoInvite (data) {
        try {
            const response = await http.post(`${PATH}/${data.id}/sso`)

            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    /**
     * @param {{email_address: string}} data
     * @returns {Promise<undefined|*>}
     */
    async resendSsoInvite (data) {
        try {
            const response = await http.post(`${PATH}/sso/resend-invite`, data)

            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    /**
     * @param {{email_address: string}} data
     * @returns {Promise<undefined|*>}
     */
    async cancelSsoInvite (data) {
        try {
            const response = await http.put(`${PATH}/sso/revoke-invite`, data)

            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    /**
     * @param {{email_address: string}} data
     * @returns {Promise<undefined|*>}
     */
    async forcePasswordChange (data) {
        try {
            const response = await http.put(`${PATH}/sso/force-reset-password`, data)

            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    /**
     * @param {{email_address: string}} data
     * @returns {Promise<undefined|*>}
     */
    async removeMfa (data) {
        try {
            const response = await http.delete(`${PATH}/sso/remove-mfa`, {data})

            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    /**
     * @param {{email_address: string}} data
     * @returns {Promise<undefined|*>}
     */
    async sendPasswordReset (data) {
        try {
            const response = await http.post(`${PATH}/sso/forgotten-password`, data)

            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    /**
     * @param {SearchQuery} params
     * @returns {Promise<void>}
     */
    async searchGroups (params) {
        try {
            const response = await http.get('/staff/groups', {params})

            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    }
}
